import { useEffect } from 'react'
import { isLogin, login } from './Cookies.js'
import {
  bootstrapNativeBridgeSync,
  consumeLaunchAccessTokenFromNative,
  syncAccessTokenWithNative,
} from './TellingPapaAppBridge.js'

const NATIVE_READY_EVENT = "tellingPapa:native-ready"


const TellingPapaAppBridgeSync = () => {
  useEffect(() => {
    const syncLoggedInSession = () => {
      const accessToken = isLogin()
      if (accessToken) {
        syncAccessTokenWithNative(accessToken)
        return
      }

      bootstrapNativeBridgeSync()
    }

    const syncLaunchAccessToken = () => {
      const launchAccessToken = consumeLaunchAccessTokenFromNative()
      if (!launchAccessToken) {
        return false
      }

      login(launchAccessToken)

      return true
    }

    const handleNativeReady = () => {
      if (syncLaunchAccessToken()) {
        return
      }

      syncLoggedInSession()
    }

    if (typeof window === "undefined") {
      syncLoggedInSession()
      return undefined
    }

    window.addEventListener(NATIVE_READY_EVENT, handleNativeReady)
    syncLoggedInSession()
    return () => {
      window.removeEventListener(NATIVE_READY_EVENT, handleNativeReady)
    }
  }, [])

  return null
}

export default TellingPapaAppBridgeSync
